<template>
    <!-- <div style="display: block; position: relative; width: 100%;"> -->
    <select ref="selectContainer" class="form-control select2" style="width: 100%;">
        <slot></slot>
    </select>
    <!-- </div> -->
</template>
<script>
export default {
    props: {
        options: {
            type: Array,
            default: () => {
                return [];
            },
            required: false
        },
        value: [String, Number, Array, Object],
        placeholder: String,
        allowClear: {
            type: Boolean,
            default: false
        },
        ajax: {
            type: String,
            required: false
        },
        minLength: {
            type: Number,
            default: 2
        },
        multiple: {
            type: Boolean,
            default: false
        },
        readonly: {
            type: Boolean,
            default: false
        },
        disabled: {type: Boolean, default: false, required: false},
        optId: { type: String, required: false },
        optText: { type: String, required: false },
        isObject: { type: Boolean, default: false }
    },

    methods: {
        transformOptions(data) {
            return data.map(v => {
                v.id = v[this.optId] || v.id;
                v.text = v[this.optText] || v.text;
                return v;
            });
        },
        setValue(value) {
            if (value === null || value === undefined || value === "") {
                $(this.$refs.selectContainer)
                    .val(null)
                    .trigger("change");
            } else if (value instanceof Object) {
                $(this.$refs.selectContainer)
                    .val(value.id)
                    .trigger("change");
            } else {
                $(this.$refs.selectContainer)
                    .val(value)
                    .trigger("change");
            }
        },
        clear() {
            $(this.$refs.selectContainer)
                .val(null)
                .trigger("change")
                .trigger("select2:unselect");
        }
    },
    data() {
        return {
            selected: {}
        };
    },
    watch: {
        options(newVal) {
            if (newVal == undefined || newVal == "" || newVal.length == 0) {
                newVal = [];
                $(this.$refs.selectContainer)
                    .select2("destroy")
                    .empty();
                $(this.$refs.selectContainer).select2({
                    data: [{ id: "0", text: this.placeholder }]
                });
            } else {
                $(this.$refs.selectContainer).select2({
                    data: this.transformOptions(newVal)
                });
                $(this.$refs.selectContainer)
                    .val(this.value)
                    .trigger("change");
            }
        },
        value(value) {
            if (value === null || value === undefined || value === "") {
                $(this.$refs.selectContainer)
                    .val(null)
                    .trigger("change");
            } else if (value instanceof Object) {
                $(this.$refs.selectContainer)
                    .val(value.id)
                    .trigger("change");
            } else {
                $(this.$refs.selectContainer)
                    .val(value)
                    .trigger("change");
            }
        }
    },
    mounted() {
        const vm = this;

        this.$nextTick(() => {
            let s2Options = {
                data: {
                    placeholder: "Selecione",
                    allowClear: vm.allowClear,
                    disabled: vm.disabled,
                    readonly: vm.readonly,
                    minimumInputLength: vm.minLength,
                    multiple: vm.multiple,
                    width: "100%"
                },
                language: {
                    noResults: function() {
                        return "Nenhum resultado.";
                    },
                    searching: function() {
                        return "Pesquisando...";
                    },
                    errorLoading: function() {
                        return "Ocorreu um problema ao carregar os resultados.";
                    },
                    loadingMore: function() {
                        return "Carregando mais resultados...";
                    },
                    inputTooShort: function(args) {
                        var remainingChars = args.minimum - args.input.length;
                        var message =
                            "Digite " + remainingChars + " ou mais caracteres.";
                        return message;
                    }
                }
            };

            if (vm.placeholder) {
                s2Options.placeholder = vm.placeholder;
            }

            if (vm.ajax) {
                s2Options.ajax = vm.ajaxUrl;
            }

            $(vm.$refs.selectContainer)
                .select2(s2Options)
                .on("select2:select", e => {
                    vm.selected = e.params.data;

                    if (vm.isObject) {
                        vm.$emit("input", e.params.data);
                        vm.$emit("change", e.params.data);
                    } else {
                        vm.$emit("input", e.params.data.id);
                        vm.$emit("change", e.params.data.id);
                    }
                })
                .on("select2:unselect", e => {
                    vm.$emit("input", null);
                });
        });
    }
};
</script>
<style lang="scss">
.select2 {
    .select2-selection {
        display: block;
        width: 100%;
        height: 35.5px;
        padding: 0.5rem 1rem;
        font-size: 0.875rem;
        line-height: 1.25;
        color: #607d8b;
        background-color: #fff;
        background-image: none;
        background-clip: padding-box;
        border: 1px solid rgba(0, 0, 0, 0.15);
        border-radius: 0;
        transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;

        .select2-selection__arrow > b {
            margin-top: 1px;
        }

        .select2-selection__rendered {
            line-height: 1.25;
        }

        & :focus {
            border-color: #79a8d2;
            outline: none;
        }
    }
}

.select2-container {
    .select2-search__field {
        border: 1px solid rgba(0, 0, 0, 0.15);
        color: #607d8b;

        & :focus {
            border-color: #79a8d2;
            outline: none;
        }
    }

    .select2-dropdown {
        border: 1px solid rgba(0, 0, 0, 0.15);
        border-radius: 0px;

        .select2-results {
            .select2-results__message {
                color: #607d8b;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// Select.vue?55068e2a